const endpoint = '/item-service/api/external/commissions/categories';

export const categoriesFeeContext = {
  categories: `${endpoint}`,
};
